import type { GQLTopProvidersPercentage } from './generated/top-providers'

export type TopProviderStats = {
  provider: GQLTopProvidersPercentage['provider']
  metrics: Array<{ type: Metric; percentage: number }>
}

export const enum Metric {
  CHEAPEST = 'CHEAPEST',
  BESTSCORE = 'BESTSCORE',
  FASTEST = 'FASTEST',
}
const MIN_BEST_SCORE = 7.0
const sourceToMetric = {
  cheapest: Metric.CHEAPEST,
  bestRated: Metric.BESTSCORE,
  fastest: Metric.FASTEST,
} as const
const fields = Object.keys(sourceToMetric) as Array<keyof typeof sourceToMetric>

export function getTopProviders(
  metrics: Record<keyof typeof sourceToMetric, GQLTopProvidersPercentage | null>,
) {
  const top: TopProviderStats[] = []
  for (const field of fields) {
    const metric = metrics[field]
    if (!metric) {
      continue
    }
    const { percentage, provider } = metric
    if (field === 'bestRated' && (!provider.score || provider.score.value < MIN_BEST_SCORE)) {
      continue
    }
    const providerInd = top.findIndex((t) => t.provider.slug === provider.slug)
    if (providerInd === -1) {
      top.push({ provider, metrics: [{ type: sourceToMetric[field], percentage }] })
    } else {
      top[providerInd].metrics.push({ type: sourceToMetric[field], percentage })
    }
  }
  return top
}
